import { z } from "zod";
import { serverResponse as orderServerResponse } from "../fetchOrder/validators";

export const serverResponse = z.object({
  orders: z.array(orderServerResponse).optional(),
  total: z.number().optional(),
  page: z.number().optional(),
  perPage: z.number().optional(),
});

export type IDispositions = z.infer<typeof serverResponse>;
